import * as types from "../actions/ActionTypes.js";
import { getErrorMessage, getErrorResponseForLinkedUsers } from "../utilities/ErrorMessageHelper";

const OperationsReducer = (state = null, action) => {
    var error;
    switch (action.type) {
    case types.VALIDATE_TICKET_FAILED:
    case types.SEND_VERIFY_EMAIL_FAILED:
    case types.GET_CURRENT_USER_FAILED:
    case types.GET_AVAILABLE_APPLICATION_FAILED:
    case types.SET_EMAIL_FAILED:
    case types.GET_VIRTUAL_USERS_BY_ORG_FAILED:
    case types.UPDATE_CURRENT_USER_PROFILE_FAILED:
    case types.LOGIN_TO_SISENSE_FAILED:
    case types.GET_VIRTUAL_PRODUCT_BY_ID_FAILED:
    case types.GET_VIRTUAL_PRODUCTS_FAILED:
        error = getErrorMessage(action.error);
        return createOperationResult(true, "Internal server error. " + error);
    case types.IMPERSONATION_FAILED:
        error = getErrorMessage(action.error);
        return createOperationResult(true, error);
    case types.LINK_USER_TO_SITE_SUCCEEDED:
        return createOperationResult(false, "Account successfully linked");
    case types.DELETE_USER_LINK_SUCCEEDED:
        return createOperationResult(false, "Account successfully unlinked");
    case types.UPDATE_USER_SUCCEEDED:
        return createOperationResult(false, "User saved successfully.");
    case types.RESEND_USER_SETPASSWORD_EMAIL_SUCCEEDED: {
        return createOperationResult(false, "Verification email sent successfully.");
    }
    case types.LINK_USER_TO_SITE_FAILED: {
        error = getErrorResponseForLinkedUsers(action.error);
        return createOperationResult(true, "Failed to link account. " + error.Message);
    }
    case types.RESET_USER_PASSWORD_FAILED:
    case types.UPDATE_USER_FAILED:
    case types.CREATE_USER_FAILED: {
        return createOperationResult(true, "Failed to save user. (" + getErrorMessage(action.error) + ")");
    }
    case types.SAVE_SETTINGS_SUCCEEDED: {
        return createOperationResult(false, "Organization preferences saved successfully");
    }
    case types.SAVE_SETTINGS_FAILED: {
        return createOperationResult(true, "Failed to save organization preferences. (" + getErrorMessage(action.error) + ")");
    }
    case types.DELETE_ORGANIZATION_LOGO_SUCCEEDED: {
        return createOperationResult(false, "Logo deleted successfully");
    }
    case types.DELETE_ORGANIZATION_LOGO_FAILED: {
        return createOperationResult(true, "Failed to delete the logo (" + getErrorMessage(action.error) + ")");
    }
    case types.SAVE_ORGANIZATION_LOGO_SUCCEEDED: {
        return createOperationResult(false, "Logo saved successfully");
    }
    case types.SAVE_ORGANIZATION_LOGO_FAILED: {
        return createOperationResult(true, "Failed to save a new logo (" + getErrorMessage(action.error) + ")");
    }
    case types.GET_ORGANIZATION_LOGO_FAILED: {
        return createOperationResult(true, "Failed to load organization logo. (" + getErrorMessage(action.error) + ")");
    }
    case types.UPDATE_CURRENT_USER_PROFILE_SUCCEEDED: {
        return createOperationResult(false, "Saved.");
    }
    default:
        return state;
    }
};

function createOperationResult (isError, message, messageType) {
    return { error: isError, message: message, type: messageType };
}

export default OperationsReducer;
